<template>
    <div :class="'popover-' + position">
        <div v-if="active" class="popover__content">
            <header class="popover__header">
                <slot name="header"></slot>
                <button class="popover__header-close" type="button" @click="close">
                    <span class="material-icons">close</span>
                </button>
            </header>

            <slot name="content"></slot>
        </div>

        <button type="button" class="popover__icon" @click="show">
            <span class="material-icons-outlined">info</span>
            <span class="material-icons">info</span>
        </button>
    </div>
</template>

<script>
export default {
    props: {
        position: {
            type: String,
            required: false,
            default: 'left'
        }
    },
    data() {
        return {
            active: false
        }
    },
    created() {
        // click outside to close
        window.addEventListener('click', (e) => {
            if (!this.$el.contains(e.target)) {
                this.close()
            }
        })
    },
    methods: {
        show() {
            this.active = true
        },
        close() {
            this.active = false
        }
    }
}
</script>
